import { staticImplements } from '@/decorators/staticImplements';
import { httpClient } from '../httpClient/httpClient';
import { InstallerRepositoryInterface } from '@/api/interfaces/installer/installerRepository';
import { Installer } from '@/api/interfaces/installer/installer';

@staticImplements<InstallerRepositoryInterface>()
export class InstallerRepository {
    static async getInstallers(): Promise<Installer[]> {
        return httpClient.get<Installer[]>(`/api/dea/v1/installer`);
    }
}
